import { Store, toImmutable, Immutable } from 'nuclear-js'
import { StoreState, Country, State, TimeZone, MapOfMaps, StandardMap } from '../types'

const storeName: string = 'geo'

const getters = {
  countries: [
    [storeName, 'countries'],
    (countriesMap: MapOfMaps): Immutable.List<StandardMap> => countriesMap?.toList()
  ],
  states: (countryId: string) => [storeName, 'states', countryId],
  timeZones: [storeName, 'timeZones']
}

const setters = {
  setCountries: (state: StoreState, countries: Country[]): StoreState => {
    return state.setIn(['countries'], Immutable.Map(countries.map(c => [c.id, c]))) // 'US': {id: 'US', name: 'United States'}
  },

  setStates: (state: StoreState, data: {countryId: number, states: State[]}): StoreState => {
    return state.setIn(['states', data.countryId], data.states)
  },

  setTimeZones: (state: StoreState, timeZones: TimeZone[]): StoreState => {
    return state.set('timeZones', Immutable.fromJS(timeZones))
  }
}

const operations = {
  setCountries: 'setCountries',
  setStates: 'setStates',
  setTimeZones: 'setTimeZones'
}

const store = new Store({
  getInitialState() {
    return toImmutable({
      countries: {},
      timeZones: []
    })
  },
  initialize() {
    const store: Store = this // for type checking
    store.on(operations.setCountries, setters.setCountries)
    store.on(operations.setStates, setters.setStates)
    store.on(operations.setTimeZones, setters.setTimeZones)
  }
})

export {
  store as geoStore,
  operations as geoOperations,
  getters as geoGetters,
  setters as geoiSetters
}
